import { render, staticRenderFns } from "./QHButton.vue?vue&type=template&id=0bc869ba"
import script from "./QHButton.vue?vue&type=script&lang=js"
export * from "./QHButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports